import { render, staticRenderFns } from "./TheOracleModuleRoleList.vue?vue&type=template&id=b85a976c&"
import script from "./TheOracleModuleRoleList.vue?vue&type=script&lang=js&"
export * from "./TheOracleModuleRoleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports